import style from './style-edit-resources';

export default {
    style,
    gap: {
        label: 'Items Gap',
        template: 'Range',
        defaultUnit: 'px',
    },
    align: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Alignment',
        isResponsible: false,
        defaultValue: 'left',
        options: [
            { label: 'Left', value: 'left', icon: 'far align-left' },
            { label: 'Center', value: 'center', icon: 'far align-center' },
            { label: 'Right', value: 'right', icon: 'far align-right' },
        ],
    },
    icon: {
        style,
        gap: {
            defaultUnit: 'px',
            template: 'Range',
            label: 'Icon & Text Gap',
        },
        position: {
            template: 'Tab',
            inputType: 'boxed',
            defaultValue: 'left',
            label: 'Icon Position',
            options: [
                { label: 'Left', value: 'left' },
                { label: 'Right', value: 'right' },
            ],
        },
    },
    direction: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Items Direction',
        defaultValue: 'horizontal',
        options: [
            { label: 'Vertical', value: 'vertical' },
            { label: 'Horizontal', value: 'horizontal' },
        ],
    },
};
